import { gql } from '@apollo/client/core';

const JobsOnboardingJobsInquiryFragment = gql`
  fragment JobsOnboardingJobsInquiryFragment on JobsInquiry {
    aeLeadSourceOther
    aeLeadSourcesMain
    aeQuotaPerPeriod
    aeQuotaTypeMain
    aeQuotaTypeOther
    baseSalary
    csmAccountsNumber
    csmQuotaMetricMain
    csmQuotaMetricOther
    csmQuotaPeriodMain
    csmQuotaPeriodOther
    csmQuotaTypeMain
    csmQuotaTypeOther
    csmRenewalValue
    csmTotalBusinessValue
    csmUpsellValue
    currency
    dealBreakerOther
    dealBreakersMain
    dealSize
    employmentTypes
    id
    idealJobDescription
    onboardingStateV2
    ote
    positionMain
    positionOther
    quotaAttainmentByTeamPerPeriod
    quotaAttainmentPerLastYear
    quotaAttainmentPerPeriod
    rankOnTeam
    revenue
    salesCycleLength
    salesMethodologies
    sdrQuotaPerPeriod
    sdrQuotaTypes
    state
    teamSize
    vpDepartmentSize
    vpManagedRoles
    vpQuotaType
    willingToRelocate
    desiredCompanySeriesStages {
      description
      id
      name
      slug
    }
  }
`;

export default JobsOnboardingJobsInquiryFragment;
